import tw, { styled } from "twin.macro";

export const CategoryTag = styled.div`
  ${tw`
    inline-flex bg-theme-blue-1 rounded-[8px] px-[12px] py-[5px]
    text-white font-bold text-[14px] leading-[16px]
  `}
`;
